export * from "./lib/ui-inherit.component"
export * from "./lib/ui-inherit.directive"
